import styles from './acces.module.css';

/** Logo transparent, avec un lettrage adapté au thème. */
export function LogoComplet() {
  return (
    <>
      <img className={`${styles.logo} cc-logo-jour`} src="/logo-transparent.png" alt="Eau Énergie Connect" width={120} height={120} />
      <img className={`${styles.logo} cc-logo-nuit`} src="/logo-transparent-nuit.png" alt="Eau Énergie Connect" width={120} height={120} />
    </>
  );
}
